'use strict';

module.exports = ['$scope', '$timeout', 'ModalSvc', 'toastr','PlantSvc', function ($scope, $timeout, ModalSvc, toastr,PlantSvc) {

    $scope.processCustomersString = function () {
         
        var customersArr = encodeURI($scope.customersString).split('%0A');

        var customers = customersArr.filter( function (value, index, self) { 
            return self.indexOf(value) === index;
        }); 

        for(var i = 0; i < customers.length; i++){
            customers[i] = decodeURI(customers[i]); 
        }

        if(customers.length > 0 && $scope.customersString != ""){
            var modalInstance = ModalSvc.importCustomers.open({ 
                customers:customers,
                plantId:$scope.$root.plant
            });
    
            modalInstance.result.then(function (data) { 
                toastr.success('Customers imported successfully!');
                $scope.customersString = "";
            });
        }
       
    };

    $scope.loadCustomers = function(){
        PlantSvc.getCustomers($scope.$root.plant).success(function(customers) {
            $scope.customersString = customers.join('\n');
        });
    }
 
    $scope.customersString = "";
}];